import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import React from 'react'
import { useSelector } from 'react-redux'
import { listBranches, listRepositories } from '../../repositories/actions'
import { branchSelector, repositorySelector } from '../../repositories/selector'
import { useAppSelector } from 'app/store'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function TagsPicklist({
  disabled = false,
  name = 'branch',
  label = 'Branch *',
  networkId = null,
  includeNoneOption = false,
  ...rest
}) {
  const { loading: loadingRepos, reload: reloadRepos } = useListAction(listRepositories)
  const repositoryDetails = useAppSelector(repositorySelector)
  const { loading, reload } = useListAction(listBranches, {
    params: { uid: repositoryDetails?.[0]?.uid },
  })
  const branches = useSelector(branchSelector)
  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading || loadingRepos}
      items={branches}
      enableSearch
      onRefresh={() => {
        reloadRepos(true)
        reload(true)
      }}
    />
  )
}
